import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "../styles/Account.css";
import "../../shared/styles/Global.css";
import getCompleteUserData from "../services/getUserData";
import updateUserData from "../services/updateUserData";

import "react-toastify/dist/ReactToastify.css";

import AppFooter from "../../shared/components/AppFooter";

const Account = () => {
  const [userData, setUserData] = useState(null);
  const [editData, setEditData] = useState({
    name: "",
    surname: "",
    city: "",
    country: "",
    phone: "",
    profession: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getCompleteUserData();
      if (data) {
        setUserData(data);
        setEditData({
          name: data.name || "",
          surname: data.surname || "",
          city: data.city || "",
          country: data.country || "",
          phone: data.phone || "",
          profession: data.profession || "",
        });
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const validateEditData = () => {
    const { name, surname, city, country, phone, profession } = editData;

    const isOnlyLetters = (text) => /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,40}$/.test(text);
    const isPhoneValid = (phone) => /^\+?[0-9]{6,20}$/.test(phone);

    if (!isOnlyLetters(name)) {
      toast.error("Nombre inválido. Solo letras, máx. 40 caracteres.");
      return false;
    }
    if (!isOnlyLetters(surname)) {
      toast.error("Apellido inválido. Solo letras, máx. 40 caracteres.");
      return false;
    }
    if (!isOnlyLetters(city)) {
      toast.error("Ciudad inválida. Solo letras, máx. 40 caracteres.");
      return false;
    }
    if (!isOnlyLetters(country)) {
      toast.error("País inválido. Solo letras, máx. 40 caracteres.");
      return false;
    }
    if (!isPhoneValid(phone)) {
      toast.error("Teléfono inválido. Solo números, entre 6 y 20 dígitos.");
      return false;
    }
    if (!isOnlyLetters(profession)) {
      toast.error("Profesión inválida. Solo letras, máx. 40 caracteres.");
      return false;
    }

    return true;
  };

  const handleUpdate = async () => {
    if (!userData?.uid) return;

    const isValid = validateEditData();
    if (!isValid) return;

    setSaving(true);
    const success = await updateUserData(userData.uid, editData);
    setSaving(false);

    if (success) {
      setUserData({ ...userData, ...editData });
      toast.success("Datos actualizados correctamente.");
    } else {
      toast.error("Ocurrió un error al actualizar los datos.");
    }
  };

  return (
    <>
      <section className="accountSection fadeIn">
        <div className="firstAccountContainer">
          <img src="/images/patientManager1.svg" alt="" />
        </div>

        <div className="secondAccountContainer">
          <div className="accountContainer">
            <h2>Mi información</h2>

            <p>
              <label className="generalFormLabel">
                Nombre
                <input
                  type="text"
                  name="name"
                  value={editData.name}
                  onChange={handleInputChange}
                  className="generalFormInput"
                />
              </label>
            </p>
            <p>
              <label className="generalFormLabel">
                Apellido/s
                <input
                  type="text"
                  name="surname"
                  value={editData.surname}
                  onChange={handleInputChange}
                  className="generalFormInput"
                />
              </label>
            </p>
            <p>
              <label className="generalFormLabel">
                Ciudad
                <input
                  type="text"
                  name="city"
                  value={editData.city}
                  onChange={handleInputChange}
                  className="generalFormInput"
                />
              </label>
            </p>
            <p>
              <label className="generalFormLabel">
                País
                <input
                  type="text"
                  name="country"
                  value={editData.country}
                  onChange={handleInputChange}
                  className="generalFormInput"
                />
              </label>
            </p>
            <p>
              <label className="generalFormLabel">
                Teléfono
                <input
                  type="text"
                  name="phone"
                  value={editData.phone}
                  onChange={handleInputChange}
                  className="generalFormInput"
                />
              </label>
            </p>
            <p>
              <label className="generalFormLabel">
                Profesión
                <input
                  type="text"
                  name="profession"
                  value={editData.profession}
                  onChange={handleInputChange}
                  className="generalFormInput"
                />
              </label>
            </p>

            <button onClick={handleUpdate} disabled={saving}>
              {saving ? "Guardando..." : "Guardar cambios"}
            </button>
          </div>

          <div className="account-actions">
            <a
              href="https://blog.patientmanager.com.ar/publicaciones/"
              className="action-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="icon">📝</span>
              <span className="text">Acceder al blog de novedades</span>
            </a>
            <a
              href="https://wa.me/5491122450678"
              className="action-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="icon">💬</span>
              <span className="text">
                Enviar mensaje al soporte por WhatsApp
              </span>
            </a>
            <a
              href="https://blog.patientmanager.com.ar/como-funciona-la-plataforma/"
              className="action-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="icon">ℹ️</span>
              <span className="text">Cómo funciona la plataforma</span>
            </a>
            <a
              href="https://forms.gle/5gyX7GQc3yWq3eLZA"
              className="action-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="icon">✉️</span>
              <span className="text">
                Solicitar cambio de correo electrónico
              </span>
            </a>
            <a
              href="https://forms.gle/MYGeEPcfTExxXR2s8"
              className="action-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="icon">🗑️</span>
              <span className="text">Solicitar baja de cuenta</span>
            </a>
          </div>
        </div>
      </section>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <AppFooter />
    </>
  );
};

export default Account;
